import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "main-wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "spinner-container text-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "mb-5" }

import { onMounted } from 'vue'
import { useAppStore } from '@/stores/app'
import { useAuthService } from './services/auth-service'


export default /*#__PURE__*/_defineComponent({
  __name: 'CartApp',
  setup(__props) {

const appStore = useAppStore()
const authService = useAuthService()

onMounted(async () => {
    await appStore.loadingWhile(async () => await authService.isAuth())
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, _hoisted_3, 512), [
      [_vShow, _unref(appStore).loading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_view)
    ], 512), [
      [_vShow, !_unref(appStore).loading]
    ])
  ]))
}
}

})